<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">{{ $t('accountEditModalTitle') }}</div>
    </template>

    <Spinner v-if="dataIsSending"/>
    <div v-else class="p-formgrid p-grid p-pt-3">
      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-5">
        <div class="p-float-label">
          <InputText id="account-modal-name"
                     :class="{'p-invalid' : submitted && !itemData.name}"
                     v-model.trim="itemData.name"
                     autocomplete="off"/>
          <label for="account-modal-name">{{ $t('Name') }}<span class="warning-color">*</span></label>
        </div>
        <small class="p-invalid" v-if="submitted && !itemData.name">{{ $t('Required field') }}</small>
      </div>

      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12" :class="{'p-mb-5' : $store.getters.isSuperAdmin}">
        <EmailInput v-model="itemData.email"
                    v-model:isInvalid="emailInvalid"
                    :submitted="submitted"
                    :required="true"
                    inputId="account-modal-email"/>
      </div>

<!--      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12" :class="{ 'p-mb-5' : $store.getters.isSuperAdmin}">-->
<!--        <EmailInput v-model="itemData.billing_email"-->
<!--                    v-model:isInvalid="billingEmailInvalid"-->
<!--                    :submitted="submitted"-->
<!--                    label="Billing Email"-->
<!--                    :required="true"-->
<!--                    inputId="account-modal-billing-email"/>-->
<!--      </div>-->

      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12" v-if="$store.getters.isSuperAdmin">
        <div class="p-float-label">
          <InputText id="account-modal-short-name"
                     :class="{'p-invalid' : submitted && !itemData.slug}"
                     v-model.trim="itemData.slug"
                     autocomplete="off"/>
          <label for="account-modal-short-name">{{ $t('Short Name') }}<span class="warning-color">*</span></label>
        </div>
        <small class="p-invalid" v-if="submitted && !itemData.slug">{{ $t('Required field') }}</small>
      </div>
    </div>
    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :label="$t('Save')" :disabled="dataIsSending" icon="pi pi-check" class="p-button-text" @click="saveItem"/>
    </template>
  </Modal>
</template>

<script>
import httpClient from '@/services/http.services'
import overlayVisibilityMixins from "@/mixins/overlayVisibilityMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import EmailInput from "@/components/EmailInput";

export default {
  components: {EmailInput},
  mixins: [ showErrorsMixins, overlayVisibilityMixins ],
  emits: ['close', 'update-items'],
  name: 'AccountModal',
  props: {
    item: Object,
    visible: Boolean,
  },
  data() {
    return {
      emailInvalid: false,
      // billingEmailInvalid: false,
      dataIsSending: false,
      itemData: {},
      submitted: false,
    }
  },
  watch: {
    item(value) {
      if (!value) return
      this.itemData = { ...value }
    },
    visible(b) {
      if (!b) {
        this.dataIsSending = false
        this.submitted = false
        this.emailInvalid = false
      }
    },
  },
  methods: {
    async saveItem() {
      this.submitted = true
      if (!this.itemData.id ||
          !this.itemData.name ||
          !this.itemData.email ||
          // !this.itemData.billing_email ||
          this.emailInvalid ||
          // this.billingEmailInvalid ||
          this.$store.getters.isSuperAdmin && !this.itemData.slug) {
        return false
      }

      this.dataIsSending = true

      const accountData = {
        id: this.itemData.id,
        name: this.itemData.name ?? null,
        email: this.itemData.email ?? null,
        // billing_email: this.itemData.billing_email ?? null,
      }

      if (this.$store.getters.isSuperAdmin) {
        accountData.slug = this.itemData.slug ?? null
      }

      try {
        const { status, data } = await httpClient.post(`account/update`, accountData)
        if (status === 200 && data?.success) {
          this.$store.commit('SET_TENANT_NAME', accountData.name)
          this.$emit('update-items', this.itemData.id)
          this.$toast.add({severity: 'success', detail: this.$t('Data updated'), life: settings.toastLife});
          this.close()
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.dataIsSending = false
      }
    },
    close() {
      this.$emit('close')
      this.submitted = false
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '95%', maxWidth: '440px', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '440px', marginTop: '25px'}
      } else {
        return {position: 'absolute', top: 0, width: '440px', marginTop: '50px'}
      }
    },
  },
}
</script>